import React from "react";
import Dashboard from "./components/Dashboard/Dashboard";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import LoginScreen from "./components/Auth/LoginScreen";
import RegisterScreen from "./components/Auth/RegisterScreen";
import useAuth from "./hooks/useAuth";
import SetupMatch from "./components/Match/SetupMatch";
import MatchScreen from "./components/Match/MatchScreen";

function App() {
  const { user, loading, logout } = useAuth();

  if (loading) return <div>Loading...</div>;

  return (
    <Router>
      <nav style={{ padding: 16, borderBottom: "1px solid #ddd", marginBottom: 24 }}>
        <Link to="/" style={{ marginRight: 16 }}>Home</Link>
        {!user && (
          <>
            <Link to="/login" style={{ marginRight: 8 }}>Login</Link>
            <Link to="/register">Register</Link>
          </>
        )}
        {user && (
          <>
            <span style={{ marginLeft: 16 }}>
              Logged in as <b>{user.email}</b>
            </span>
            <button onClick={logout} style={{ marginLeft: 16, padding: "4px 12px" }}>
              Log Out
            </button>
          </>
        )}
      </nav>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/setup-match" element={<SetupMatch />} />
        <Route path="/match" element={<MatchScreen />} />
        <Route path="/" element={
          user ? <Navigate to="/dashboard" replace /> : (
            <div style={{ padding: "2rem" }}>
              <h1>Welcome to Court Side v3</h1>
              <p>Please login or register to continue.</p>
            </div>
          )
        } />
      </Routes>
    </Router>
  );
}

export default App;
